<template>
  <section class="msgList all_dongtai_list">
    <ul class="allList" v-model="allTrend">
      <li class="list-item" v-for="(item, item_index) in allTrend" :key="item_index" :user_id="item.user_id" :id="item.id" style="border: none;background: #fff;margin: 0 0 10px 0;padding:10px 0 25px;border-bottom: solid 1px #f7f5f5;">
        <div class="item_header avatar" style="position: relative;">
          <img v-show="item.v_status" src="@/assets/img/v_status.png" style="position: absolute; top:0.45rem; left: 0.45rem; width: 25px; height: 25px;">
          <img class="avatar_img" v-if="item.avatar" :src="item.avatar" style="width: 44px;height: 44px;margin-right: 15px;" @click="toMineTrend(item.user_id)"/>
          <img class="avatar_img" v-else src="@/assets/img/avatar.jpg" style="width: 44px;height: 44px;margin-right: 15px;" @click="toMineTrend(item.user_id)"/>
          <p class="item_header_info auther" style="font-size: 15px">
            <span v-if="item.user_nickname" class="user_nickname" style="margin-top: 19px;">{{ item.user_nickname }}</span>
            <span v-else class="user_nickname" style="margin-top: 19px;">{{ $t("匿名用户") }}</span>
            <svg v-if="item.user_id != userInfo.id" t="1652760828922" @click="showSheet(item)" style="float: right; width: 15px;height: 15px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1248" width="200" height="200"><path d="M830.24 340.688l11.328 11.312a16 16 0 0 1 0 22.624L530.448 685.76a16 16 0 0 1-22.64 0L196.688 374.624a16 16 0 0 1 0-22.624l11.312-11.312a16 16 0 0 1 22.624 0l288.496 288.496 288.512-288.496a16 16 0 0 1 22.624 0z" p-id="1249" fill="#8a8a8a"></path></svg>
          </p>
          <p style="margin-top: 5px;">
            <span class="createTime detail" style="float: left;">{{ item.create_time }}</span>
            <a v-if="item.user_id == userInfo.id" href="javascript:;" style="float: right; font-size: 10px; padding: 0;color: #237acf;" @click="deleteTrend(item.id)">{{ $t("删除") }}</a>
          </p>
        </div>
        <div class="item_content newsbox">
          <p>
                <span v-show="item.tags&&item.tags[0]&&item.tags[0].tag_name" v-for="(tag,tag_index) in item.tags">
                  <span class="no_bubble" style="color: rgba(43,95,233,1);font-weight: bold;display: inline;"># {{ tag.tag_name }} #</span>
                </span>
            <span v-show="item.viewpoint_id&&item.viewpoint_id > 0">
                  <span class="no_bubble" style="color: rgba(43,95,233,1);font-weight: bold;display: inline;"># {{ item.viewpoint_title }} #</span>
                </span>
            <span v-if="item.content.length>200">
                  <span style="display: block;" @click="toDetail(item)">{{item.content.replace(item.content.substr(200), '...') }}</span>
                  <br>
                  <span style="font-size: 16px;">
                    <span class="quanwen" style="color: #237acf;display: block;" @click="showContent($event)" :item_index="item_index">{{ $t("全文") }}</span>
                    <span class="qubuneirong" style="display: none;">
                        <span style="display: block; " @click="toDetail(item)">{{item.content }}</span>
                      <br>
                        <span class="shouqi" style="color: #237acf;display: block;" @click="showContent1($event)">{{ $t("收起") }}</span>
                      </span>
                  </span>
                </span>
            <span v-else style="display: block;" @click="toDetail(item)">{{item.content }}</span>
          </p><br />
          <div class="item_img">
            <div class="dongtai_twoimg" v-for="(img, img_index) in item.image">
              <img :src="img" class="two_img">
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="item_footer comment">
          <div class="comment_cell" v-for="(comment, comment_index) in item.comments" v-show="comment_index<2">
            <p>
              <span class="user_nickname" v-if="comment.user_nickname"> {{ comment.user_nickname }}:</span>
              <span class="user_nickname" v-else>{{ $t("匿名用户") }}</span>
              <span class="content">{{ comment.content }} </span>
            </p>
          </div>
          <div v-show="item.comments.length>0" class="look_all_comment" @click="toDetail(item)">{{ $t("查看所有评论") }}>>
          </div>
        </div>
        <div class="op">
          <div class="caozuo">
            <div>
              <img src="@/assets/img/ico1.png">{{$t('分享')}}
            </div>
          </div>
          <div class="caozuo" @click="toDetail(item)">
            <div>
              <img src="@/assets/img/ico2.png">
              <span v-if="item.comment_count < 1">{{ $t("评论") }}</span>
              <span v-else>{{ item.comment_count }}</span>
            </div>
          </div>
          <div class="caozuo" @click="toLike(item)">
            <div>
              <img v-if="item.is_liked" src="@/assets/img/ico3_on.png" alt="">
              <img v-else src="@/assets/img/ico3.png" alt="">
              <span v-if="item.like_count < 1">{{ $t("赞") }}</span>
              <span v-else>{{ item.like_count }}</span>
            </div>
          </div>
          <!--            <div class="caozuo">-->
          <!--              <div >-->
          <!--                <img src="@/assets/img/ico4.png">-->
          <!--                <span>举报-->
          <!--                </span>-->
          <!--              </div>-->
          <!--            </div>-->
        </div>
        <mt-actionsheet
            :actions="actions"
            v-model="sheetVisible"
        >
        </mt-actionsheet>
      </li>
    </ul>
  </section>
</template>

<script>
import {delMoment, getMoment, likeOrNotLike, banUser} from "../../api/trend";
import {MessageBox, Toast} from "mint-ui";

export default {
  name: "Trend",
  props: {
    allTrend: Array,
    refreshUrl: Object
  },
  data() {
    return {
      userInfo: this.$store.state.userInfo,
      sheetVisible:false,
      showInfo:{},
      actions:[
        {
          name: this.$t('屏蔽'),
          method: this.shieldTrend
        },
        {
          name: this.$t('投诉'),
          method: this.complaintTrend
        }
      ]
    }
  },
  methods: {
    deleteTrend(trendId) {
      MessageBox.confirm(this.$t('确定删除该动态吗') + '?').then(action => {
        if (action == 'confirm') {
          delMoment({id: trendId}).then(res => {
            Toast(this.$t('删除成功！'))
            this.refreshData(this.refreshUrl)
          })
        }
      });
    },
    showContent(e) {
      e.target.style.display = 'none'
      e.target.parentNode.parentNode.firstChild.style.display = 'none'
      e.target.parentNode.children[1].style.display = 'block'
    },
    showContent1(e) {
      e.target.parentNode.style.display = 'none'
      e.target.parentNode.parentNode.firstChild.style.display = 'block'
      e.target.parentNode.parentNode.parentNode.children[0].style.display = 'block'
    },
    toDetail(item) {
      this.$router.push({path: "/trend_detail", query: {id: item.id}})
    },
    toMineTrend(user_id) {
      this.$router.push({path: "/trend_mine", query: {id: user_id}})
    },
    //点赞
    toLike(item) {
      let type = 0;
      if (item.is_liked == 0) {//当前未点赞
        type = 0;
      } else {
        type = 1;
      }

      let data = {
        moment_id: item.id,
        type: type
      }
      likeOrNotLike(data).then(res => {
        if (res.code == 1) {
          // MessageBox.alert(res.msg, "提示")
          if (type == 0) {
            item.is_liked = 1
            item.like_count = item.like_count + 1
          } else {
            item.is_liked = 0
            item.like_count = item.like_count - 1
          }
        }
      })
    },
    refreshData(data) {
      this.limit_begin = 0
      getMoment(data)
          .then((res) => {
            this.allTrend = res.data.list
            loaded('done')
          })
    },
    showSheet(item){
      this.sheetVisible = true;
      this.showInfo = item;
    },
    shieldTrend(){
      MessageBox.confirm(this.$t('确定屏蔽此用户的所有动态?')).then(action => {
        const params = {
          type:'user',
          ban_id:this.showInfo.user_id
        }
        banUser(params).then(res => {
          if (res.code == 1) {
            MessageBox.alert(res.msg, this.$t("提示"))
            console.log(this.refreshUrl,'LLLLLLLLLLLLLLLLLLLLLLLLL')
            this.refreshData(this.refreshUrl)
          }
        })
      });

    },
    complaintTrend(){
      this.$router.push({path: "/trend_complaint", query: {trend_id: this.showInfo.id,user_nickname:this.showInfo.user_nickname}})
    }
  }
}
</script>

<style scoped>
/*.msgList{ padding:.2rem .35rem 0; }*/
.msgList ul li{border-bottom:1px solid #e6e6e6;padding:.4rem 0;}
.msgList .avatar{overflow:hidden;height:4rem;padding:.0rem 0 0;color: #000;}
.msgList .avatar img{border-radius:50%;width:.8rem;height:.8rem;float:left;}
.msgList .avatar .detail {color:#999;font-size:.25rem;font-size: 12px}
.msgList .op{margin: 16px auto 0;}
.msgList .op a{padding-left:.4rem;color: #999;height:.35rem;margin-right:4%}
.msgList .op .btn_share{background: url(../../assets/img/ico1.png) no-repeat 0 center;background-size: .35rem;}
.msgList .op .btn_chat{background: url(../../assets/img/ico2.png) no-repeat 0 center;background-size: .35rem;}
.msgList .op .btn_like{background: url(../../assets/img/ico3.png) no-repeat 0 center;background-size: .35rem;}
.msgList .op .btn_likeon{background: url(../../assets/img/ico3_on.png) no-repeat 0 center;background-size: .35rem;}
.msgList .newsbox a.more{padding: .15rem 0 .2rem;display: block;color: #2eccfa;}
.msgList .newsbox p{overflow: hidden;display: -webkit-box;-webkit-line-clamp: 30;-webkit-box-orient: vertical;word-break: break-all;}
.newsbox{
  font-size: 16px;
  color: #000;
}
.dongtai_twoimg{
  height: 120px;
  width: 32%;
  float: left;
  margin: 0 1% 3px 0;
  overflow: hidden;
  vertical-align: middle;
  position: relative;
}
.two_img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.clear{zoom: 1;}
.clear{
  clear: both;
}
.clear:after {
  display: block;
  content: "";
  clear: both;
  height: 0;
  overflow: hidden;
}
.comment {
  background: #fbfbfb;
  padding: 0 10px;
  margin-top: 10px;
}

.comment .look_all_comment {
  padding: 6px 0 10px;
  font-size: 12px;
  line-height: 16px;
  color: #237acf;
}

.comment .comment_cell {
  padding: 6px 0 0 0;
  color: #333;
  font-size: 12px;
  line-height: 16px;
}

.comment .comment_cell .user_nickname {
  color: #237acf;
}
.op .caozuo {
  /*width: 24.9%;*/
  text-align: left;
  display: inline-block;
  color: #666;
  font-size: 14px;
  padding-right: 20px;
}

.op .caozuo img {
  width: 20px;
  display: inline;
  vertical-align: middle;
  margin: 0 5px 0 0;
}
.allList{
  background: #fff;
  padding: 15px 20px;
  font-family: PingFang;
  overflow: auto;
  /*margin-bottom: 500px;*/
}
.msgList .avatar .auther .sheetImage{
  width: 15px;
  height: 10px;
  float: right;
}
.mint-actionsheet{
  bottom: 55px;
  border-radius: 15px 15px 0 0;
}
.mint-actionsheet ul, .mint-actionsheet ul:first-child li {
  border-radius: 15px 15px 0 0;
}
.content{
  white-space: normal;
  word-wrap: break-word;
}
</style>
